<template>
  <div class="ibox deployment-customization">
    <div class="ibox-title">
      <h2>{{ $t('hospitality.deployment.validation.title') }}</h2>
    </div>
    <div :class="'ibox-content p-md' + (listLoading ? ' sk-loading' : '')">

      <div v-if="listLoading" class="sk-spinner sk-spinner-double-bounce">
          <div class="sk-double-bounce1"></div>
          <div class="sk-double-bounce2"></div>
      </div>

      <p>{{ $t('hospitality.deployment.validation.note') }}</p>
      <a v-if="siteValidationLink" class="btn btn-primary" :href="siteValidationLink" target="_blank">{{$t('hospitality.deployment.validation.button-site', {'domain': siteTopLevelDomain})}}</a>

    </div>
  </div>
</template>

<script lang="ts">
import { Ref, defineComponent, PropType, computed, onMounted, onBeforeUnmount, ref, watch, reactive } from '@fwk-node-modules/vue'
import { getApp, useRouter, useStore } from '@fwk-client/utils/vue-3-migration';

import { useSiteAdmin } from '../../../../cms/composables/useSiteAdmin';
import { useAgencyAdmin } from '../../../composables/useAgencyAdmin';

export default defineComponent({
    props: {
        
    },
    components: {
    },
    setup(props, context) {
      const app = getApp();
      const $router = useRouter();
      const $store = useStore();

      const { selectedAgency, selectedSite } = useAgencyAdmin(props, context);
      const { getSiteValidationLink } = useSiteAdmin(props, context);

      const listLoading:Ref<boolean> = ref(false);

      const siteTopLevelDomain = computed(() => {
        return selectedSite.value ? selectedSite.value.topLevelDomain : undefined;
      })

      const siteValidationLink = computed(() => {
        return getSiteValidationLink(selectedSite.value);
      });

      return { 
        listLoading,
        siteTopLevelDomain,
        siteValidationLink
      }
    }
})
</script>